import { createLucideIcon } from './lucideIcon'

export const Search = createLucideIcon(
  'Search',
  <>
    <path d="m21 21-4.34-4.34" />
    <circle cx="11" cy="11" r="8" />
  </>
)
